import { IApplicationState } from "store/types";

export const selectDownTime = (state: IApplicationState) =>
  state.maintenance.data?.downtime;
